export default "__VITE_ASSET__9BdD2akR__"